import React, { useEffect, useRef } from "react";
import { ScreenShare } from "lucide-react";

/** Dedicated "main stage" tile for an active screen-share track (local or remote).
 * Uses object-contain (not object-cover) so shared slides/text never get cropped. */
export function LiveKitScreenShareTile({ track, name, isSelf }) {
  const videoElRef = useRef(null);

  useEffect(() => {
    const el = videoElRef.current;
    if (el && track) {
      track.attach(el);
      return () => track.detach(el);
    }
  }, [track]);

  if (!track) return null;

  return (
    <div className="relative bg-black rounded-xl overflow-hidden aspect-video border border-cyan-400/30 mb-3" data-testid={`livekit-screenshare-tile-${isSelf ? "self" : name}`}>
      <video ref={videoElRef} autoPlay playsInline className="w-full h-full object-contain" />
      <div className="absolute top-2 left-2 flex items-center gap-1.5 bg-black/60 backdrop-blur-sm rounded-md px-2.5 py-1">
        <ScreenShare className="w-3.5 h-3.5 text-cyan-300" />
        <span className="text-xs text-white font-medium">{isSelf ? "You are presenting" : `${name} is presenting`}</span>
      </div>
    </div>
  );
}
